import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from 'anatoliapps-angular/services';

import { Product } from 'hakikat/models';
import { API_CONFIG } from 'hakikat/utils';

@Injectable({
  providedIn: 'root'
})
export class ProductService extends ApiService {

  //#region Endpoints
  readonly #PRODUCTS_ENDPOINT = 'product';
  //#endregion

  //#region Constructor
  constructor() { super(API_CONFIG.apiUrl); }
  //#endregion

  //#region Methods
  public getProduct(id: string): Observable<Product> {
    return this.get<Product>(`${this.#PRODUCTS_ENDPOINT}/${id}`);
  }
  //#endregion
  
}
